export var PaymentReminderReaction = /*#__PURE__*/function (PaymentReminderReaction) {
  PaymentReminderReaction["postpone"] = "postpone";
  PaymentReminderReaction["confirm"] = "confirm";
  return PaymentReminderReaction;
}(PaymentReminderReaction || {});
export const PaymentReminderReactionOptions = [{
  value: PaymentReminderReaction.postpone,
  label: 'Vertagt'
}, {
  value: PaymentReminderReaction.confirm,
  label: 'Zahlung bestätigt'
}];
export const PaymentReminderReactionOrderPriorities = {
  [PaymentReminderReaction.postpone]: 0,
  [PaymentReminderReaction.confirm]: 1
};